import { RouteConfig } from 'vue-router'
import Main from '../Alarm/Main.vue'

export const alarmRoutes: RouteConfig = {
  path: '/alarm',
  name: 'alarm',
  component: Main
}
